<div class="form-group">
  <div class="col-sm-12">
    <button type="button" class="btn btn-primary" title="{{'ADD' | translate}}" 
    *ngIf="allowCreate && enableManageAttaches && (!limitNumberOfFiles || (limitNumberOfFiles && listFiles != null && listFiles.length < 1))" (click)="addFileOpen()">
      <i class="fas fa-plus"></i>&nbsp;{{'ADD' | translate}}
    </button>
  </div>
</div>

<div class="form-group">
  <div class="col-sm-12">
    <div class="table-responsive">
      <table id= {{tableID}} class="table table-bordered display table-actions" cellspacing="0">
        <thead>
          <tr>
            <th class="text-center"><strong>{{ 'FILE' | translate}}</strong></th>
            <th class="text-center"><strong>{{ 'TYPE' | translate}}</strong></th>
            <th class="text-center"><strong>{{ 'DESCRIPTION' | translate}}</strong></th>
            <th class="text-center"><strong>{{ 'DATE' | translate}}</strong></th>
            <th class="text-center"><strong>{{ 'DUE_DATE' | translate}}</strong></th>
            <th class="text-center"><strong>{{ 'PUBLIC' | translate}}</strong></th>
            <th class="text-center"></th>
            <th class="text-center"></th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>
  </div>
</div>